import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { handleAuthentication } from "@containers/App/reducer"
import { parseLayoutData } from "./parser"
import { getCityFromSlug } from "./LabDetailUtils"

const initialState = {
    isLoading: false,
    isFetched: false,
    isFetchError: false,
    error: null,
    layout: {},
    labsDetailsData: {},
}

export const labDetailsPageSlice = createSlice({
    name: "labDetailsPage",
    initialState: initialState,
    reducers: {
        reset: () => initialState,
        setLabsDetailsData: (state, action) => {
            state.labsDetailsData = action.payload.data
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLabDetailsData.fulfilled, (state, action) => {
            state.isLoading = false
            state.isFetched = true
            state.isFetchError = false
            state.error = null
            let data = parseLayoutData(action.payload)
            state.layout = data
        }),
            builder.addCase(fetchLabDetailsData.pending, (state) => {
                state.isLoading = true
                state.isFetched = false
                state.error = false
            }),
            builder.addCase(fetchLabDetailsData.rejected, (state, action) => {
                state.isLoading = false
                state.error = true
                state.isFetched = false
                state.error = action.payload
                state.isFetchError = true
            })
    },
})

export const fetchLabDetailsData = createAsyncThunk(
    "labDetailsPage/fetchLabDetailsData",
    async (_arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        const labId = _arg?.labId
        const cityInURL = _arg?.cityInURL
        const city = getCityFromSlug(cityInURL)
        try {
            const res = await api.get(`/api/labs/v1/labs/${labId}?city=${city}`)
            return Promise.resolve(res?.data)
        } catch (err) {
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue(err)
        }
    }
)

export const labDetailsPageReducer = labDetailsPageSlice.reducer
export const { reset, setLabsDetailsData } = labDetailsPageSlice.actions
